module.exports = __webpack_public_path__ + "abe8ff4488707c3b161885b3b4b9d2e4.pdf";